'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeSunburstIcon = function TraceTypeSunburstIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 60 60' }, props),
        _react2.default.createElement('circle', { cx: '29.31', cy: '31.08', r: '14.14', fill: '#3cb5e8' }),
        _react2.default.createElement('path', { d: 'M29.24 47.68A16.82 16.82 0 0 1 21 45.5l2.17-3.82a12.52 12.52 0 0 0 18.58-10.92h4.41a16.94 16.94 0 0 1-16.92 16.92z', fill: '#7cc6e6' }),
        _react2.default.createElement('path', { d: 'M20.23 47.09a18.67 18.67 0 0 1 9.34-34.83v18.67M29.57 30.93h18.67a18.67 18.67 0 0 0-18.67-18.67v18.67', fill: '#08507a' }),
        _react2.default.createElement('path', { d: 'M19.46 48.5A20 20 0 1 1 49 30.93h-3.82a16.21 16.21 0 1 0-23.91 14.24z', fill: '#3cb5e8' }),
        _react2.default.createElement('path', { d: 'M29.29 31.31h-12.1a12.1 12.1 0 0 1 12.1-12.1z', fill: '#3cb5e8' }),
        _react2.default.createElement('path', { d: 'M31.38 32.49L40 37.63a11.08 11.08 0 0 1-8.41 5.49l-.25-10.63', fill: '#08507a' }),
        _react2.default.createElement('circle', { cx: '29.61', cy: '30.35', r: '7.32', fill: '#fff' }),
        _react2.default.createElement('circle', { cx: '29.61', cy: '30.35', r: '3.1', fill: '#08507a' })
    );
};

exports.default = TraceTypeSunburstIcon;